// 기간 이동 ‹ 2026-09 › (시안 .period). value 'YYYY-MM', onChange('YYYY-MM'), label (앞 라벨, 선택)
import React from 'react';
import { T, R, NUM } from '../theme';

var wrap = { display: 'inline-flex', alignItems: 'center', gap: 2, border: '1px solid ' + T.bd, borderRadius: 7, background: T.card, height: 28 };
var arrow = { padding: '0 8px', fontSize: 12, color: T.muted, background: 'none', border: 'none', cursor: 'pointer', height: '100%', fontFamily: 'inherit' };
var val = Object.assign({ fontSize: 12.5, color: T.ink, fontWeight: 700, minWidth: 56, textAlign: 'center' }, NUM);

export function shiftMonth(ym, delta) {
  var m = /^(\d{4})-(\d{2})$/.exec(String(ym || ''));
  if (!m) return ym;
  var d = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1 + delta, 1);
  var mo = d.getMonth() + 1;
  return d.getFullYear() + '-' + (mo < 10 ? '0' + mo : '' + mo);
}

function PeriodNav(props) {
  var go = function (d) { if (props.onChange) props.onChange(shiftMonth(props.value, d)); };
  return (<span style={wrap} className="v2-period">
    {props.label ? <span style={{ fontSize: 11.5, color: T.muted, paddingLeft: 8, borderRadius: R.sm }}>{props.label}</span> : null}
    <button type="button" aria-label="이전 달" style={arrow} onClick={function () { go(-1); }}>‹</button>
    <b style={val}>{props.value || '-'}</b>
    <button type="button" aria-label="다음 달" style={arrow} onClick={function () { go(1); }}>›</button>
  </span>);
}

export default PeriodNav;
